module.exports = __webpack_public_path__ + "img/FUTURE_Iso_Quad_unten.b89dc2e3.svg";